import { route, number, union, boolean, string } from 'react-router-typesafe-routes';

import { ACTIVITY_FILTER_VALUES } from '../components/Activities/utils/activitiesFilters';
import { MessageChannel } from '../types/messageChannel';
import { PRODUCT_FILTER_VALUES, STATUS_FILTER_VALUES, SORT_OPTIONS_VALUES } from '../components/Orders/utils/filterConfig';

import { ModalName } from './modalRoutes';

const MODAL_VALUES = [
  ModalName.Dialer,
  ModalName.Settings,
  ModalName.Logs,
  ModalName.AgentsList,
  ModalName.DTMF,
] as const;

export const ROUTES = route({
  searchParams: {
    modal: union(MODAL_VALUES),
  },
  children: {
    calls: route({
      path: 'calls',
    }),
    call: route({
      path: 'call/:callId',
      params: { callId: number() },
    }),
    callNew: route({
      path: 'call/new',
      searchParams: {
        sid: string(),
      },
    }),
    customers: route({
      path: 'customers',
      searchParams: {
        activeOnly: boolean(),
        search: string(),
        staff: string(),
      },
    }),
    customer: route({
      path: 'customer/:customerId',
      params: { customerId: number() },
      searchParams: {
        message_channel: union([MessageChannel.SMS]),
        text: string(),
        to: string(),
      },
    }),
    activities: route({
      path: 'activities',
      searchParams: {
        filter: union(ACTIVITY_FILTER_VALUES),
        important: boolean(),
        staff: string(),
      },
    }),
    aiAgent: route({ path: 'ai-agent' }),
    orders: route({
      path: 'orders',
      searchParams: {
        product: union(PRODUCT_FILTER_VALUES),
        status: union(STATUS_FILTER_VALUES),
        sort: union(SORT_OPTIONS_VALUES),
        staff: string(),
      },
    }),
    salesToolkit: route({ path: 'sales-toolkit' }),
  },
});
